<template>
  <div>
    <ed-table
      registerName="Inserir Novo LTCAT"
      :onRegister="(!validarPacote(27) ? null : onRegister)"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :onSearch="getLtcat"
      :onFilter="getLtcat"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
      :filterBadge="filterBadge"
    >
      <div slot="table-filter-content">
        <ed-form :data="formFilter" :config="config" :response="response" :itens="filterItems" />
      </div>
    </ed-table>
  </div>
</template>

<script>
import EdTable from "common/table";
import EdForm from "common/form";
import Rest from "common/rest";
import Fct from "common/fct";
import FilterItems from "./_form/ltcat-filter";

export default {
  name: "ltcat",
  components: { EdTable, EdForm },
  mixins: [Rest],
  data() {
    return {
      config: {
        click: {
          id_empresa: this.getEmpresa
        },
        list: {
          id_empresa: []
        },
        loading: {
          id_empresa: false
        }
      },
      formFilter: {
        id_empresa: null,
        vencimento: []
      },
      pagination: {},
      response: {},
      tableHead: [
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          label: "Empresa"
        },
        {
          key: "revisao",
          sortable: true,
          label: "Tipo de Revisão"
        },
        {
          key: "vencimento",
          sortable: true,
          label: "Vencimento"
        },
        {
          key: "updated_at",
          sortable: true,
          show_user: true,
          label: "Atualização"
        }
      ],
      tableData: [],
      filterItems: [],
      loadingTable: true,
      loadingEditAll: false,
      filterBadge: 0
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {},

  mounted() {
    this.getLtcat();
    this.getEmpresa();
    this.filterItems = FilterItems;
  },

  methods: {
    onRegister: function() {
      this.$router.push({ name: "ltcat.cadastrar" });
    },

    onEdit: function(data) {
      this.$router.push({ name: "ltcat.editar", params: { id: data.id } });
    },

    onDelete: function(data) {
      var self = this;

      this.$confirm(
        "O sistema vai excluir " +
          data.length +
          " registro(s). Deseja prosseguir?",
        "Atenção",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      ).then(() => {
        self.loadingEditAll = true;
        self.loadingTable = true;

        this.post("/ltcat/deletar", { ids: data }).then(result => {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcat();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    getEmpresa(search) {
      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("empresa", { search: search }).then(result => {
        result = result[0];

        this.config.loading.id_empresa = false;

        if (result.status == 200) {
          this.config.list.id_empresa = result.data.data;
        }
      });
    },

    getLtcat: function(_search, _page, _pagination, _loading) {
      this.loadingTable = true;
      this.response = {};

      this.filterBadge =
        (this.formFilter.id_empresa ? 1 : 0) +
        (this.formFilter.vencimento && this.formFilter.vencimento.length == 2
          ? 1
          : 0);

      this.get("ltcat", {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: this.formFilter
      }).then(result => {
        result = result[0];
        this.response = result;
        this.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
            tableData = [],
            self = this,
            pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var revisao =
              data[i].rev +
              " (" +
              data[i].descricao +
              " em " +
              this.toDate(data[i].data, true) +
              ")";

            if (data[i].parent) {
              revisao =
                data[i].parent.rev +
                " (" +
                data[i].parent.descricao +
                " em " +
                this.toDate(data[i].parent.data, true) +
                ") / " +
                revisao;
            }

            var item = {
              empresa: data[i].empresa.nome,
              vencimento: data[i].vencimento
                ? this.toDate(data[i].vencimento, true)
                : "---",
              revisao: revisao,
              updated_at: this.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                style: !data[i].parent ? "font-weight:bold" : "",
                disable_delete: !this.validarPermissao(567),
                disable_edit: !this.validarPermissao(567)
              },
              buttons: []
            };
            tableData.push(item);
          }

          this.pagination = pagination;
          this.tableData = tableData;
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// index.vue?31ecb15a